const validateForm2 = (formData) => {
  const errors = {};
  //! First Name validation
  if (!formData.firstName?.trim()) {
    errors.firstName = "This field is required";
  } else if (!/^[a-zA-Z0-9\-.'_]+$/.test(formData.firstName)) {
    errors.firstName =
      "Characters allowed: a-z A-Z 0-9 and - . ' _";
  }

  //! Last Name validation
  if (!formData.lastName?.trim()) {
    errors.lastName = "This field is required";
  } else if (!/^[a-zA-Z0-9\-.'_]+$/.test(formData.lastName)) {
    errors.lastName =
      "Characters allowed: a-z A-Z 0-9 and - . ' _";
  }
  //! Date of Birth validation
  if (!formData.dateOfBirth) {
    errors.dateOfBirth = "Date of birth is required";
  } else {
      const birthDate = new Date(formData.dateOfBirth);
        const today = new Date();
        
        if (birthDate >= today) {
          errors.dateOfBirth = "Date of birth must be in the past";
          errors.dateOfBirth = "Date of birth must be in the past";
        } else {
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          
          if (age < 18) {
            errors.dateOfBirth = "Please enter age above 18 years";
            errors.dateOfBirth = "Please enter age above 18 years";
          }
        }
  }
  //! SSN validation
  if (!formData.ssnNo) {
    errors.ssnNo = "SSN is required";
  } else if (!/^\d{4}$/.test(formData.ssnNo)) {
    errors.ssnNo = "SSN must be exactly 4 digits";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
export default validateForm2;
